export default "__VITE_ASSET__W8XQb8vK__"